import { DownOutlined } from '@ant-design/icons';
import { FunctionComponent, ReactNode, useState } from 'react';

interface PageBannerProps {
    title: string;
    children?: ReactNode;
    storageKey?: string;
}

const PageBanner: FunctionComponent<PageBannerProps> = ({ title, children, storageKey }) => {
    const key = storageKey ?? `banner-collapsed-${title}`;
    const [collapsed, setCollapsed] = useState(() => {
        try { return localStorage.getItem(key) === '1'; } catch { return false; }
    });

    const toggle = () => {
        setCollapsed((prev) => {
            const next = !prev;
            try { localStorage.setItem(key, next ? '1' : '0'); } catch { /* ignore */ }
            return next;
        });
    };

    return (
        <div
            className="documents-page__header"
            role="banner"
            onClick={toggle}
            style={{ cursor: 'pointer', userSelect: 'none' }}
            aria-expanded={!collapsed}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                <h1 className="documents-page__title" style={{ margin: 0, flex: 1 }}>
                    {title}
                </h1>
                <DownOutlined
                    style={{
                        fontSize: 13,
                        color: '#6b7280',
                        marginTop: 6,
                        flexShrink: 0,
                        transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s',
                    }}
                />
            </div>
            {!collapsed && children && (
                <div style={{ marginTop: 4 }}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageBanner;
